import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Host,
  HostBinding,
  Inject,
  Input,
  Output,
} from '@angular/core';
import {
  FreelancerHttpConfig,
  FREELANCER_HTTP_CONFIG,
} from '@freelancer/freelancer-http';
import {
  OverlayTypes,
  PaymentsEventType,
  PaymentsMessagingService,
  PaymentsOverlay,
} from '@freelancer/payments-messaging';
import { PaymentsPopUpService } from '@freelancer/payments-popup';
import { PaymentsUtils } from '@freelancer/payments-utils';
import { Tracking } from '@freelancer/tracking';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-payments-captcha',
  template: `
    <app-payments-overlay
      (overlayOn)="handleOverlayOn()"
    ></app-payments-overlay>
  `,
  styleUrls: ['./payments-captcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // injecting this again separates this service from the top one
  providers: [PaymentsMessagingService],
})
export class PaymentsCaptchaComponent {
  @HostBinding('attr.data-visible') captchaOpened: boolean;
  overlay: PaymentsOverlay;

  @Input() set captchaRequired(captchaRequired: boolean) {
    this.handleCaptchaRequired(captchaRequired);
  }

  get captchaRequired() {
    return this.captchaOpened;
  }

  @Output() captchaResolved = new EventEmitter<boolean>();

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(FREELANCER_HTTP_CONFIG)
    private freelancerHttpConfig: FreelancerHttpConfig,
    private popUpService: PaymentsPopUpService,
    private tracking: Tracking,
    // https://angular.io/guide/dependency-injection-in-action#qualify-dependency-lookup-with-optional-and-host
    @Host() private paymentsMessaging: PaymentsMessagingService,
    private paymentsUtils: PaymentsUtils,
  ) {}

  initCaptchaPopUp() {
    return this.popUpService.openPopUp('flnBlnCaptcha').then(popUp => {
      this.getThreeDSDepositResultPromise().then(data => {
        this.tracking.trackCustomEvent('FlnBlnCaptchaResolved');
        this.captchaResolved.emit(true);
        this.popUpService.closePopUp();
        this.closeOverlay();
      });
      popUp.location.href = `${this.freelancerHttpConfig.baseUrl}/payments/flnbln-captcha-resolve.php`;
    });
  }

  getThreeDSDepositResultPromise(): Promise<MessageEvent['data']> {
    return this.paymentsUtils
      .getFilteredMessageStream(
        // TODO: move to common
        event => event.data.type === 'capture_resolved',
      )
      .pipe(take(1))
      .toPromise();
  }

  closeOverlay() {
    this.paymentsMessaging.pushEvent({
      eventType: PaymentsEventType.CLOSE_OVERLAY,
    });
  }

  handleCaptchaRequired(captchaRequired: boolean) {
    this.captchaOpened = captchaRequired;
    if (captchaRequired) {
      this.tracking.trackCustomEvent('FlnBlnCaptchaRequired');
      this.paymentsMessaging.pushOverlay({
        ctaAction: () => this.initCaptchaPopUp(),
        overlayType: OverlayTypes.CC_CAPTCHA,
      });
    } else if (this.popUpService.isOpened) {
      this.tracking.trackCustomEvent('FlnBlnCaptchaCancelled');
      this.popUpService.closePopUp();
    }
  }

  handleOverlayOn() {
    this.cdr.detectChanges();
  }
}
